// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Td-module__Container__YFlcs {
    display: flex;
    align-items: center;
    padding: var(--ds-sm) var(--ds-m);
}
/* Enable text truncation for flex children */
.Td-module__Container__YFlcs > * {
    min-width: 0;
}

.Td-module__Container__YFlcs:focus-visible {
    border-radius: var(--ds-border-radius-sm);
    outline: var(--ds-05x) solid var(--ds-color-focus-outline);
    outline-offset: calc(var(--ds-05x) * -1);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Td-module__Container__YFlcs`
};
export default ___CSS_LOADER_EXPORT___;
